import { makeGetRequest }  from 'lib/axios';
import { UserSession } from 'types';

/**
 * Make API request for rosie user session
 * @returns 
 */
 const getUserSession = async (): Promise<UserSession> => {
  const url = `/auth/account`;
  const response = await makeGetRequest(url);
  return response.data.payload;
};

export default getUserSession;